"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { supabaseBrowser } from "@/lib/supabase/browser";

function extractClubIdFromPath(pathname: string): string | null {
  const match = pathname.match(/^\/clubs\/([^/]+)/);
  return match ? match[1] : null;
}

export function useAppSessionTracker() {
  const pathname = usePathname();
  const lastTrackedPathRef = useRef<string>("");

  useEffect(() => {
    let cancelled = false;

    async function track() {
      if (!pathname) return;
      if (lastTrackedPathRef.current === pathname) return;

      const { data } = await supabaseBrowser.auth.getUser();
      const user = data.user;
      if (!user || cancelled) return;

      const clubId = extractClubIdFromPath(pathname);

      await supabaseBrowser.rpc("track_app_session", {
        p_user_id: user.id,
        p_club_id: clubId,
        p_path: pathname,
        p_timeout_minutes: 30,
      });

      if (!cancelled) {
        lastTrackedPathRef.current = pathname;
      }
    }

    void track();

    return () => {
      cancelled = true;
    };
  }, [pathname]);

  useEffect(() => {
    let cancelled = false;

    const interval = window.setInterval(async () => {
      const currentPath = window.location.pathname;
      if (!currentPath) return;

      const { data } = await supabaseBrowser.auth.getUser();
      const user = data.user;
      if (!user || cancelled) return;

      const clubId = extractClubIdFromPath(currentPath);

      await supabaseBrowser.rpc("track_app_session", {
        p_user_id: user.id,
        p_club_id: clubId,
        p_path: currentPath,
        p_timeout_minutes: 30,
      });
    }, 5 * 60 * 1000);

    return () => {
      cancelled = true;
      window.clearInterval(interval);
    };
  }, []);
}